import { useGtm, createGtm } from '@gtm-support/vue-gtm'

export default defineNuxtPlugin((nuxtApp) => {
  const publicConfig = useRuntimeConfig().public
  const route = useRoute()

  if (publicConfig.environment !== 'production') console.log('pluginVueGtm: init', publicConfig.gtmId)

  if (publicConfig.gtmId) {
    nuxtApp.vueApp.use(createGtm({
      id: publicConfig.gtmId,
      defer: true,
      debug: publicConfig.environment !== 'production',
      vueRouter: null,
    }))
  }

  return {
    provide: {
      gtmEvent (params) {
        useGtm().trackEvent(
          params,
        )
      },
      pushGtmMountedTrigger() {
        const pageTitle = (typeof document !== 'undefined' && document.title) || ''
        if (publicConfig.environment !== 'production') console.log('pluginVueGtm: pushGtmMountedTrigger', useGtm(), pageTitle)
        useGtm().trackEvent({
          event: 'nuxtRoute',
          pageUrl: `/${publicConfig.chainKey}/${publicConfig.paddingedChainId}${route.fullPath}`, 
          routeName: route.name,
          pageTitle: (typeof document !== 'undefined' && document.title) || '',
        })
      },
      pushGtmContentLoad(pageUrl, pageTitle) {
        if (publicConfig.environment !== 'production') console.log('pluginVueGtm: pushGtmContentLoad', useGtm(), pageTitle)
        useGtm().trackEvent({
          event: 'content_scroll_load',
          pageUrl: pageUrl, 
          routeName: route.name,
          pageTitle: pageTitle,
        })
      },
    },
  }
})
